<script setup lang="ts">
  import { ref, onUnmounted } from "vue";
  import { useCheckAlarming } from "./useCheckAlarming";
  import { default as CheckAlarmingSingle } from "./CheckAlarmingSingle.vue";
  import { default as CheckAlarmingMulti } from "./CheckAlarmingMulti.vue";

  const emit = defineEmits<{ (e: "close"): void }>();
  const { clear } = useCheckAlarming();

  const mode = ref<"single" | "multi">("multi");

  onUnmounted(clear);
</script>

<template>
  <div class="widget-check-alarming" data-testid="widget-check-alarming">
    <CheckAlarmingSingle v-if="mode === 'single'" @close="mode = 'multi'" />
    <CheckAlarmingMulti v-else @close="emit('close')" @activate:mode_single="mode = 'single'" />
  </div>
</template>

<style scoped>
  .widget-check-alarming {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }
</style>
